import GoogleOneTapJppSecondStepModal from '.';

export const loadGoogleOneTapJppSecondStepModal = (idToken: string, jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  new GoogleOneTapJppSecondStepModal(
    'google-one-tap-jpp-second-step-modal',
    'jr-modal-wrapper',
    idToken,
    jrConfigGlobal
  ).init();
}